export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";

export const API_ERROR = "LOGIN_API_ERROR";

export const GET_CURRENT_USER = "GET_CURRENT_USER";
export const GET_CURRENT_USER_WALLET_ADDRESS = "GET_CURRENT_USER_WALLET_ADDRESS";
export const GET_CURRENT_USER_SUCCESS = "GET_CURRENT_USER_SUCCESS";
export const GET_CURRENT_USER_FAIL = "GET_CURRENT_USER_FAIL";

export const GET_SETTINGS = "GET_SETTINGS";
export const GET_SETTINGS_SUCCESS = "GET_SETTINGS_SUCCESS";
export const GET_SETTINGS_FAIL = "GET_SETTINGS_FAIL";

//request for verification
export const REQUEST_FOR_VERIFICATION = "REQUEST_FOR_VERIFICATION";
export const REQUEST_FOR_VERIFICATION_SUCCESS =
  "REQUEST_FOR_VERIFICATION_SUCCESS";
export const REQUEST_FOR_VERIFICATION_FAIL = "REQUEST_FOR_VERIFICATION_FAIL";

export const COLLECTION_REQ_FOR_VERIFICATION =
  "COLLECTION_REQ_FOR_VERIFICATION";
export const COLLECTION_REQ_FOR_VERIFICATION_SUCCESS =
  "COLLECTION_REQ_FOR_VERIFICATION_SUCCESS";
export const COLLECTION_REQ_FOR_VERIFICATION_FAIL =
  "COLLECTION_REQ_FOR_VERIFICATION_FAIL";

//  FORTGET PASSWORD
export const FORGET_PASSWORD = "FORGET_PASSWORD";
export const FORGET_PASSWORD_SUCCESSFUL =
  "FORGET_FORGET_PASSWORD_SUCCESSFULASSWORD_SUCCE";
export const FORGET_PASSWORD_FAILED = "FORGET_PASSWORD_FAILED";

// Verify OTP
export const VERIFY_OTP = "VERIFY_OTP";
export const VERIFY_OTP_SUCCESSFUL = "VERIFY_OTP_SUCCESSFUL";
export const VERIFY_OTP_FAILED = "VERIFY_OTP_FAILED";
// verify email 
export const VERIFY_EMAIL_REQUEST = "VERIFY_EMAIL_REQUEST";
// resend otp
export const VERIFY_EMAIL_AGAIN_REQUEST = "VERIFY_EMAIL_AGAIN_REQUEST";
export const VERIFY_EMAIL_AGAIN_SUCCESS = "VERIFY_EMAIL_AGAIN_SUCCESS";
export const VERIFY_EMAIL_AGAIN_FAIL = "VERIFY_EMAIL_AGAIN_FAIL";
// PASSWORD RESET
export const PASSWORD_RESET = "PASSWORD_RESET";
export const PASSWORD_RESET_SUCCESSFUL = "PASSWORD_RESET_SUCCESSFUL";
export const PASSWORD_RESET_FAILED = "PASSWORD_RESET_FAILED";
// get particular user
// PASSWORD RESET
export const GET_PARTIULAR_USER = "GET_PARTIULAR_USER";
export const GET_PARTIULAR_USER_SUCCESSFUL = "GET_PARTIULAR_USER_SUCCESSFUL";
export const GET_PARTIULAR_USER_FAILED = "GET_PARTIULAR_USER_FAILED";


// polygon id sign in 
// PASSWORD RESET
export const POLYGON_SIGN_IN = "POLYGON_SIGN_IN";
export const POLYGON_SIGN_IN_FAILED = "POLYGON_SIGN_IN_FAILED";
export const POLYGON_SIGN_IN_SUCCESSFUL = "POLYGON_SIGN_IN_SUCCESSFUL";

// polygon auth update 
export const POLYGON_AUTH_UPDATE = "POLYGON_AUTH_UPDATE";
export const POLYGON_AUTH_UPDATE_FAILED = "POLYGON_AUTH_UPDATE_FAILED";
export const POLYGON_AUTH_UPDATE_SUCCESSFUL = "POLYGON_AUTH_UPDATE_SUCCESSFUL";

